import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { DoodleBolt, DoodleSignal, DoodleCursor, FloatingDoodle } from "./Doodles";
import { useLanguage } from "@/contexts/LanguageContext";

const CTASection = () => {
  const { t } = useLanguage();

  return (
    <section className="relative py-24 bg-gradient-hero overflow-hidden">
      {/* Grid pattern overlay */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: "linear-gradient(hsl(var(--primary-foreground)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--primary-foreground)) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      <div className="pointer-events-none absolute inset-0">
        <FloatingDoodle delay={0} duration={5} y={10}>
          <DoodleBolt className="absolute top-12 left-[8%] text-accent/25" />
        </FloatingDoodle>
        <FloatingDoodle delay={1} duration={4}>
          <DoodleSignal className="absolute top-20 right-[6%] text-primary-foreground/15" />
        </FloatingDoodle>
        <FloatingDoodle delay={2} duration={6} y={8}>
          <DoodleCursor className="absolute bottom-12 left-[12%] text-primary-foreground/10" />
        </FloatingDoodle>
      </div>

      <div className="container relative mx-auto px-4">
        <motion.div
          className="mx-auto max-w-2xl text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-4xl font-bold text-primary-foreground">
            {t("landing.cta_title")}
          </h2>
          <p className="mt-4 text-lg text-primary-foreground/70">
            {t("landing.cta_desc")}
          </p>
          <Button size="lg" className="mt-8 h-12 px-8 text-base shadow-glow" asChild>
            <Link to="/signup">
              {t("landing.cta_button")}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
